import {SelectOptionsType} from 'global';
export interface FieldValues {
    value?: string;
    selectedOption?: SelectOptionsType;
    multiSelectedOptions?: SelectOptionsType[];
    booleanValue?: boolean | null;
    integerValue?: number | null;
}
export interface DefaultFieldValue {
    options: SelectOptionsType[];
}
export interface ItemDataFieldModel {
    uniqueId: string;
    columnSize?: number | null;
    fieldCategory: FieldCategory;
    fieldType: FieldTypeEnum;
    dataType: DataType;
    regularExpression: string;
    title: string;
    order: number;
    placeHolder: string;
    helperText?: string;
    isRequired: boolean;
    defaultValue?: DefaultFieldValue;
    value: FieldValues;
    validationMessage: string;
    isReadOnly?: boolean;
    shouldUseAsTheFieldToCreateItem: boolean;
    format?: string;
    formula?: string;
    isMultiValue?: boolean;
}
export enum FieldCategory {
    Action = 'ACTION',
    Data = 'DATA',
    Information = 'INFORMATION',
    Inputs = 'INPUTS',
    None = 'NONE',
}

export enum FieldTypeEnum {
    TimeTrackerCounter = 'TIME_TRACKER_COUNTER',
    None = 'NONE',
    Text = 'TEXT',
    Email = 'EMAIL',
    Phone = 'PHONE',
    NUMBER = 'NUMBER',
    TextArea = 'TEXT_AREA',
    Radio = 'RADIO',
    SelectList = 'SELECT_LIST',
    Action = 'ACTION',
    UploadFile = 'UPLOAD_FILE',
    AssignTo = 'ASSIGN_TO',
    DateTime = 'DATE_TIME',
    Date = 'DATE',
    Time = 'TIME',
    SelectListWithColor = 'SELECT_LIST_WITH_COLOR',
    TextEditor = 'TEXT_EDITOR',
    CheckBox = 'CHECKBOX',
    ItemStatus = 'itemStatusId',
    AppEventTriggersSelect = 'APP_EVENT_TRIGGERS_SELECT',
    IntegrationSelectList = 'INTEGRATION_SELECT_LIST',
}

export enum DataType {
    None = 'NONE',
    Integer = 'INTEGER',
    String = 'STRING',
    Date = 'DATE',
    File = 'FILE',
    Time = 'TIME',
    DateTime = 'DATETIME',
    Boolean = 'BOOLEAN',
    SelectOptionWithColor = 'SELECT_OPTION_WITH_COLOR',
    SelectOption = 'SELECT_OPTION',
    Double = 'DOUBLE',
}

export enum FieldConstantsVariables {
    AssignUserFullName = 'assignUserFullName',
    AssignUserLastName = 'assignUserLastName',
    AssignUserFirstName = 'assignUserFirstName',
    TicketNo = 'ticketNo',
    timeTrackerCounter = 'timeTrackerCounter',
}

// export const replaceTheSelectedOptionValueToValue = (field: ItemDataFieldModel[]): ItemDataFieldModel[] => {
//     return field.map(item => {
//         if (item.value) {
//             try {
//                 if (item.fieldType === FieldTypeEnum.AssignTo) {
//                     const selectedOption = JSON.parse(item.value) as SelectOptionsType;
//                     item.value = selectedOption.value;
//                 } else if (item.fieldType === FieldTypeEnum.SelectList) {
//                     const selectedOption = JSON.parse(item.value) as SelectOptionsType;
//                     item.value = selectedOption.value;
//                 } else if (item.fieldType === FieldTypeEnum.SelectListWithColor) {
//                     const selectedOption = JSON.parse(item.value) as SelectOptionsType;
//                     item.value = selectedOption.value;
//                 }
//             } catch (error) {}
//         }
//         return item;
//     });
// };

// export const getTheOptionValue = (field: ItemDataFieldModel[]): ItemDataFieldModel[] => {
//     return field.map(item => {
//         if (item.value) {
//             try {
//                 if (item.fieldType === FieldTypeEnum.SelectList || item.fieldType === FieldTypeEnum.AssignTo) {
//                     const options = JSON.parse(item.defaultValue) as SelectListType[];
//                     const selectedOption = options.find(option => option.value === item.value);
//                     if (selectedOption) {
//                         item.value = JSON.stringify(selectedOption);
//                     }
//                 } else if (item.fieldType === FieldTypeEnum.SelectListWithColor) {
//                     const options = JSON.parse(item.defaultValue) as SelectListTypeWithColor[];
//                     const selectedOption = options.find(option => option.value === item.value);
//                     if (selectedOption) {
//                         item.value = JSON.stringify(selectedOption);
//                     }
//                 }
//             } catch (error) {}
//         }
//         return item;
//     });
// };
